export const IsEventFromActionItem: (event: Event) => boolean = (event: Event): boolean => {
    const clickedElement: HTMLElement | null = event.target as HTMLElement;
    const isChildOfActionItem: HTMLElement | null = clickedElement ? clickedElement.closest('sh-action-item') : null;

    return !!isChildOfActionItem;
};
